// src/components/DraggableModuleItem.jsx

import React from 'react';
import { ListItem, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { Draggable } from 'react-beautiful-dnd';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import TitleIcon from '@mui/icons-material/Title';
import SubjectIcon from '@mui/icons-material/Subject';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ImageIcon from '@mui/icons-material/Image';
import EditIcon from '@mui/icons-material/Edit';
import EmailIcon from '@mui/icons-material/Email';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import TableChartIcon from '@mui/icons-material/TableChart';
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import DateRangeIcon from '@mui/icons-material/DateRange';
import ScheduleIcon from '@mui/icons-material/Schedule';
import InfoIcon from '@mui/icons-material/Info';
import DescriptionIcon from '@mui/icons-material/Description';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const DraggableModuleItem = React.memo(({ field, index }) => {
  const MODULE_ICONS = {
    header: <TitleIcon />,
    subheader: <TitleIcon />,
    paragraph: <SubjectIcon />,
    user_details: <EditIcon />,
    email: <EmailIcon />,
    signature: <EditIcon />,
    short_answer: <TextFieldsIcon />,
    double_short_answer: <TextFieldsIcon />,
    long_answer: <TextFieldsIcon />,
    checkbox: <CheckBoxIcon />,
    checkbox_group: <CheckBoxIcon />,
    custom_checkbox_group: <CheckBoxIcon />,
    radio_button_group: <RadioButtonCheckedIcon />,
    table: <TableChartIcon />,
    dropdown_select: <ArrowDropDownCircleIcon />,
    image: <ImageIcon />,
    image_upload: <CloudUploadIcon />,
    datetime: <AccessTimeIcon />,
    date_range: <DateRangeIcon />,
    time_range: <ScheduleIcon />,
    site_information_viewer: <InfoIcon />,
    document_checker: <DescriptionIcon />,
    hazard_register: <ReportProblemIcon />,
    // Add other mappings as necessary
  };

  return (
    <Draggable draggableId={field.id} index={index}>
      {(provided, snapshot) => (
        <Tooltip title={`Drag to add a ${field.label} to the form`}>
          <ListItem
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            sx={{
              padding: '8px 16px',
              backgroundColor: snapshot.isDragging ? '#d1eaff' : '#f9f9f9',
              borderRadius: 1,
              marginBottom: 1,
              cursor: 'grab',
              transition: 'background-color 0.2s',
              boxShadow: snapshot.isDragging ? '0 4px 8px rgba(0,0,0,0.2)' : '0 1px 3px rgba(0,0,0,0.1)',
            }}
          >
            <ListItemIcon>
              {MODULE_ICONS[field.type] || <DragIndicatorIcon />}
            </ListItemIcon>
            <ListItemText primary={field.label} />
          </ListItem>
        </Tooltip>
      )}
    </Draggable>
  );
});

export default DraggableModuleItem;
